import * as ActionTypes from '../Actions/EnumTypes/ActionEnumTypes';
import { AOIAction } from '../Actions/Models/AOIActionModel';
import * as Types from '../../Models/AOIModel';

export type State = Types.AOIStore;

export const initialState: State = {
    aoiList: [],
    activeAoi: null,
    aoiDetailsPopupVisible: false,
    newZoneLatLng: []
};

export function aoiReducer(state: State = initialState, action: AOIAction): State {
    switch (action.type) {
        case ActionTypes.AOI.GET_AOI_LIST_SUCCESS: {
            return {
                ...state,
                aoiList: action.payload.aoiList
            };
        }
        // case ActionTypes.AOI.GET_AOI_LIST_FAILURE: {
        //     return {
        //         ...state
        //     };
        // }
        // case ActionTypes.AOI.ADD_AOI_SUCCESS: {
        //     return {
        //         ...state
        //     };
        // }
        // case ActionTypes.AOI.UPDATE_AOI_SUCCESS: {
        //     return {
        //         ...state
        //     };
        // }
        // case ActionTypes.AOI.ADD_AOI_FAILURE: {
        //     return {
        //         ...state
        //     };
        // }
        case ActionTypes.AOI.DELETE_AOI_SUCCESS: {
            return {
                ...state,
                activeAoi: null,
                aoiDetailsPopupVisible: false
            };
        }
        // case ActionTypes.AOI.DELETE_AOI_FAILURE: {
        //     return {
        //         ...state
        //     };
        // }
        case ActionTypes.AOI.SET_DETAILS_FOR_AOI_VIEW: {
            return {
                ...state,
                activeAoi: action.payload.activeAoi
            };
        }
        case ActionTypes.AOI.AOI_DETAILS_POPUP_SHOW: {
            return {
                ...state,
                aoiDetailsPopupVisible: true
            };
        }
        case ActionTypes.AOI.AOI_DETAILS_POPUP_HIDE: {
            return {
                ...state,
                aoiDetailsPopupVisible: false
            };
        }
        case ActionTypes.AOI.ADD_COORDS_TO_NEW_ZONE: {
            const coords = action.payload.newZoneCoord;
            const stateCopy = [...state.newZoneLatLng];
            stateCopy.push(coords);
            return {
                ...state,
                newZoneLatLng: stateCopy
            };
        }
        case ActionTypes.AOI.CLEAR_COORDS_OF_NEW_ZONE: {
            return {
                ...state,
                newZoneLatLng: []
            };
        }
        case ActionTypes.AOI.GET_AOI_LIST_FAILURE:
        case ActionTypes.AOI.ADD_AOI_SUCCESS:
        case ActionTypes.AOI.UPDATE_AOI_SUCCESS:
        case ActionTypes.AOI.ADD_AOI_FAILURE:
        case ActionTypes.AOI.DELETE_AOI_FAILURE:
        default: {
            return {
                ...state
            };
        }
    }
}



// WEBPACK FOOTER //
// ./src/Redux/Reducers/AOIReducer.ts